export const GLOBAL_STYLES = `
    /* Color Variables */
    .community__root {
        --community-color-primary-blue: #005EA8;
        --community-color-primary-text: #333333;
        --community-color-secondary-text: #666666;
        --community-color-error-red: #D32F2F;
        --community-color-badge-red: #E30613;
        --community-color-snow-white: #FFFFFF;
        --community-color-dark-gray: #DCDCDC;
        --community-color-dark-blue: #063773;
        --community-color-light-teal: #3CA7AC;
        --community-color-deep-sky-blue: #065B7D;
        --community-color-bellflower-blue: #e6ebf1;
        --community-color-blue-stone: #006366;
        --community-color-white-smoke: #F7F7F7;
        --community-color-bright-azure: #0563C1;
        --community-color-deep-navy: #022D94;
        --community-color-powder-blue: #cdf7fd;
        --community-color-mint-cyan: #52ecc5;
        --community-color-bakers-chocolate: #663500;
        --community-color-spring-lobster: #660031;
        --community-color-moderate-orange: #b39656;
        --community-action-buttons-background-color: #EFF2F5;
        --community-color-pastel-light-angora-blue: #cdd7e3;
        --community-color-light-steal-blue: #50739d;
        --community-color-chapeau-violet: #dce3eb;
        --community-color-strong-red: #C82D2D;
        --community-color-sunset-orange: #f07c01;
        --community-color-deep-atlantic-teal: #005c61;
    
        --community-color-transparent-black-20: #00000033;
        --community-color-transparent-black-50: #00000080;
        --community-color-transparent-black-05: #0000000d;
        --community-color-transparent-black-disabled: #00000020;
        --community-color-transparent-white-90: #ffffffe6;
        --community-color-transparent-white-80: #ffffffCC;
        --community-color-transparent-white-50: #ffffff80;
        --community-color-transparent-light-steal-blue-10: #50739d1a;
        --community-color-transparent-light-steal-blue-20: #50739d33;
        --community-color-transparent-light-steal-blue-50: #50739d80;
        --community-color-washed-denim: #829bb9;
        --community-color-saturated-orange: #9d6430;
        --community-color-saturated-red: #962222;
        --community-color-early-dew: #44b700;
        --community-color-iris-orchid: #B76190;
        --community-search-bar-height: 56px;
        --community-comment-input-height: 56px;
        --community-header-bar-height: 48px;
        --community-c24-mobile-header-bar-height: 40px;
        /*--community-c24-desktop-header-bar-height: 116px;*/
    
        --community-search-bar-minus-offset: calc(-1 * var(--community-search-bar-height));
        --community-fallback-background-color: var(--community-color-deep-sky-blue);
        --community-avatar-background-color: var(--community-color-blue-stone);
        --community-own-avatar-background-color: var(--community-color-dark-blue);
        --community-own-comment-background-color: var(--community-color-bellflower-blue);
        --community-own-message-background-color: var(--community-color-light-steal-blue);
        --community-comment-background-color: var(--community-color-white-smoke);
        --community-message-background-color: var(--community-color-white-smoke);
        --community-active-action-buttons-background-color: var(--community-color-pastel-light-angora-blue);
        --community-group-avatar-background-color: var(--community-color-bakers-chocolate);
        --community-public-group-avatar-background-color: var(--community-color-spring-lobster);
        --community-placeholder-color: var(--community-color-secondary-text);
    
        --community-reaction-like-color: var(--community-color-light-steal-blue);
        --community-reaction-love-color: #ff4033;
        --community-reaction-laugh-color: #fdca47;
        --community-reaction-hushed-color: #fdca47;
        --community-reaction-sad-color: #fdca47;
        --community-reaction-dislike-color: #f34e4a;
        --community-active-game-in-progress: var(--community-color-early-dew);
    }
    
    /* Global Styles */
    .community__root {
        overflow-x: hidden;
        background-color: transparent;
    }
    
    /* Touch Devices */
    @media (pointer:none), (pointer:coarse) {
        .community__root p, .community__root img, .community__root  div[role="button"] {
            -webkit-user-select: none !important;
            -webkit-touch-callout: none !important;
        }
    }

    @supports (padding-top:env(safe-area-inset-top)) {
        .community__root {
            --safe-area-inset-bottom: env(safe-area-inset-bottom, 0);
            --safe-area-inset-top: env(safe-area-inset-top, 0);
            --safe-area-inset-left: env(safe-area-inset-left, 0);
            --safe-area-inset-right: env(safe-area-inset-right, 0);
        }
    }

    /* Media Queries */
    @media screen and (min-width: 881px) {
        .community__root {
            --community-footer-bar-height: 64px; /* Adjust as needed */
        }
    
        .community__root p:not(.fontFamily-inherited), .community__root span:not(.fontFamily-inherited), .community__root section, .community__root article, .community__root div, .community__root a, .community__root h1, .community__root h2, .community__root h3, .community__root h4, .community__root h5, .community__root h6, .community__root button {
            font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif !important;
            -webkit-text-size-adjust: none !important;
            -webkit-font-smoothing: antialiased;
        }
    
        .community__root .MuiTooltip-tooltip p:not(.fontFamily-inherited), .community__root .MuiTooltip-tooltip button, .community__root .MuiTypography-root:not(.fontFamily-inherited) {
            font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif !important;
            -webkit-text-size-adjust: none !important;
            -webkit-font-smoothing: antialiased;
        }
    }
    
    @media screen and (max-width: 880px) {
        .community__root {
            --community-footer-bar-height: 56px; /* Adjust as needed */
        }
    
        .community__root p:not(.fontFamily-inherited), .community__root span:not(.fontFamily-inherited), .community__root section, .community__root article, .community__root div, .community__root a, .community__root h1, .community__root h2, .community__root h3, .community__root h4, .community__root h5, .community__root h6, .community__root button {
            font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif !important;
            -webkit-text-size-adjust: none;
            -webkit-font-smoothing: antialiased;
        }
    }
    
    @media screen and (max-device-width: 840px) {
        .community__root {
            --community-c24-desktop-header-bar-height: 40px;
        }
    }
    
    @media screen and (min-device-width: 841px) {
        .community__root {
            --community-c24-desktop-header-bar-height: 72px;
        }
    }
    
    @media screen and (min-device-width: 881px) {
        .community__root {
            --community-c24-desktop-header-bar-height: 76px;
        }
    }
    
    .community__root * {
        box-sizing: inherit;
    }

    .community__root {
        display: flex;
        flex: 1;
        width: 100%;
        box-sizing: border-box
    }
    
    .community__root .hidden {
        display: none !important;
    }
    
    .community__root .show {
        display: block;
    }
    
    .community__root .hideNavButtons .ril__navButtons {
        display: none;
    }
    
    .community__root textarea {
        font-family: inherit;
    }
    
    .gm-style div {
        border: none !important; /* Prevents random blue borders from Google Maps API */
    }
    
    .community__root .cover {
        background-color: #222;
        opacity: 0.8;
        position: absolute;
        right: 0;
        top: 0;
        left: 4px;
        bottom: 0;
        border-radius: 4px;
    }
    
    .community__root .cover-text {
        right: 0;
        left: 0;
        bottom: 0;
        color: white;
        font-size: 7%;
        position: absolute;
        top: 50%;
        -webkit-transform: translate(0%, -50%);
        -ms-transform: translate(0%, -50%);
        transform: translate(0%, -50%);
        text-align: center;
    }
    
    .community__root .cover-text > p {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    .community__root .slide {
        height: 0;
        bottom: 100%;
        transition: 0.3s ease;
        overflow: hidden;
        font-size: 3%;
    }
    
    .community__root .border:hover .slide {
        bottom: 0;
        height: auto;
    }
    
    .community__root .border:hover .animate-text {
        top: 62%;
    }
`;

export const SWIPER_GLOBAL_STYLES = `
    /* Leading Actions */
    .community__root .leading-actions {
        display: flex;
    }
    .community__root .leading-actions > * {
        width: 0;
        overflow-x: hidden;
    }
    
    /* Swipeable List */
    .community__root .swipeable-list {
        flex: 1;
        width: 100%;
        height: 100%;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
    }
    
    /* Swipeable List Item */
    .community__root .swipeable-list-item {
        position: relative;
        transition: max-height 0.5s ease-in-out;
        max-height: 1000px;
        transform-origin: top;
        width: 100%;
    }
    .community__root .swipeable-list-item--remove {
        max-height: 0;
        transition: max-height 0.35s ease-out;
    }
    .community__root .swipeable-list-item__content {
        width: 100%;
        align-items: center;
        box-sizing: border-box;
        height: 100%;
        display: flex;
    }
    .community__root .swipeable-list-item__content--return {
        transition: transform 0.5s ease-in-out;
    }
    
    /* Keyframe Animations */
    @keyframes content-return-leading-ms {
        20% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(0);
        }
    }
    @keyframes content-return-trailing-ms {
        20% {
            transform: translateX(-100%);
        }
        100% {
            transform: translateX(0);
        }
    }
    
    /* Swipeable List Item Actions */
    .community__root .swipeable-list-item__leading-actions {
        position: absolute;
        display: flex;
        width: 0px;
        overflow: hidden;
        height: 100%;
    }

    .community__root .swipeable-list-item__actions--return-ms {
        animation-duration: 0.5s;
        animation-name: actions-return-ms;
        animation-timing-function: linear;
    }
    
    /* Trailing Actions */
    .community__root .swipeable-list-item__trailing-actions {
        display: flex;
        width: 0px;
        position: absolute;
        right: 0;
        top: 0;
        justify-content: flex-end;
        overflow: hidden;
        height: 100%;
    }
    
    /* Swipe Action */
    .community__root .swipe-action {
        display: flex;
        width: 100%;
        align-items: stretch;
    }

    .community__root .swipe-action > * {
        flex: 1;
    }

    .community__root .swipe-action__grayed > * {
        background-color: gray !important;
    }

    .community__root .swipe-action__leading > * {
        justify-content: flex-start;
    }

    .community__root .swipe-action__trailing > * {
        justify-content: flex-end;
    }

    .community__root .swipe-action__leading--full-swipe-rest,
    .community__root .swipe-action__trailing--full-swipe-rest {
        width: 0;
        transition: width 0.2s;
    }

    .community__root .swipe-action__leading--full-swipe-main > * {
        justify-content: flex-end;
    }

    .community__root .swipe-action__trailing--full-swipe-main > * {
        justify-content: flex-start;
    }

    /* Trailing Actions */
    .community__root .trailing-actions {
        display: flex;
    }

    .community__root .trailing-actions > * {
        width: 0;
        overflow-x: hidden;
    }
    
    .community__root {
        .swiper-button-prev,
        .swiper-button-next {
          position: absolute;
          top: var(--swiper-navigation-top-offset, 50%);
          width: calc(var(--swiper-navigation-size) / 44 * 27);
          height: var(--swiper-navigation-size);
          margin-top: calc(0px - (var(--swiper-navigation-size) / 2));
          z-index: 10;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--swiper-navigation-color, var(--swiper-theme-color));
          &.swiper-button-disabled {
            opacity: 0.35;
            cursor: auto;
            pointer-events: none;
          }
          &.swiper-button-hidden {
            opacity: 0;
            cursor: auto;
            pointer-events: none;
          }
          .swiper-navigation-disabled & {
            display: none !important;
          }
          svg {
            width: 100%;
            height: 100%;
            object-fit: contain;
            transform-origin: center;
          }
          .swiper-rtl & svg {
            transform: rotate(180deg);
          }
        }
        .swiper-button-prev,
        .swiper-rtl .swiper-button-next {
          left: var(--swiper-navigation-sides-offset, 10px);
          right: auto;
        }
        .swiper-button-next,
        .swiper-rtl .swiper-button-prev {
          right: var(--swiper-navigation-sides-offset, 10px);
          left: auto;
        }
        .swiper-button-lock {
          display: none;
        }
        /* Navigation font start */
        .swiper-button-prev,
        .swiper-button-next {
          &:after {
            font-family: swiper-icons;
            font-size: var(--swiper-navigation-size);
            text-transform: none !important;
            letter-spacing: 0;
            font-variant: initial;
            line-height: 1;
          }
        }
        .swiper-button-prev,
        .swiper-rtl .swiper-button-next {
          &:after {
            content: '';
          }
        }
        .swiper-button-next,
        .swiper-rtl .swiper-button-prev {
          &:after {
            content: '';
          }
          right: var(--swiper-navigation-sides-offset, 10px);
          left: auto;
        }
        
 .swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
  display: block;
}
.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
  box-sizing: content-box;
}
.swiper-android .swiper-slide,
.swiper-ios .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}
.swiper-horizontal {
  touch-action: pan-y;
}
.swiper-vertical {
  touch-action: pan-x;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
  display: block;
}
.swiper-slide-invisible-blank {
  visibility: hidden;
}
/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}
.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}
/* 3D Effects */
.swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper {
  transform-style: preserve-3d;
}
.swiper-3d {
  perspective: 1200px;
  .swiper-slide,
  .swiper-cube-shadow {
    transform-style: preserve-3d;
  }
}

/* CSS Mode */
.swiper-css-mode {
  > .swiper-wrapper {
    overflow: auto;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
    &::-webkit-scrollbar {
      display: none;
    }
  }
  > .swiper-wrapper > .swiper-slide {
    scroll-snap-align: start start;
  }
  &.swiper-horizontal {
    > .swiper-wrapper {
      scroll-snap-type: x mandatory;
    }
  }
  &.swiper-vertical {
    > .swiper-wrapper {
      scroll-snap-type: y mandatory;
    }
  }
  &.swiper-free-mode {
    > .swiper-wrapper {
      scroll-snap-type: none;
    }
    > .swiper-wrapper > .swiper-slide {
      scroll-snap-align: none;
    }
  }
  &.swiper-centered {
    > .swiper-wrapper::before {
      content: '';
      flex-shrink: 0;
      order: 9999;
    }
    > .swiper-wrapper > .swiper-slide {
      scroll-snap-align: center center;
      scroll-snap-stop: always;
    }
  }
  &.swiper-centered.swiper-horizontal {
    > .swiper-wrapper > .swiper-slide:first-child {
      margin-inline-start: var(--swiper-centered-offset-before);
    }
    > .swiper-wrapper::before {
      height: 100%;
      min-height: 1px;
      width: var(--swiper-centered-offset-after);
    }
  }
  &.swiper-centered.swiper-vertical {
    > .swiper-wrapper > .swiper-slide:first-child {
      margin-block-start: var(--swiper-centered-offset-before);
    }
    > .swiper-wrapper::before {
      width: 100%;
      min-width: 1px;
      height: var(--swiper-centered-offset-after);
    }
  }
}

/* Slide styles start */
/* 3D Shadows */
.swiper-3d {
  .swiper-slide-shadow,
  .swiper-slide-shadow-left,
  .swiper-slide-shadow-right,
  .swiper-slide-shadow-top,
  .swiper-slide-shadow-bottom,
  .swiper-slide-shadow,
  .swiper-slide-shadow-left,
  .swiper-slide-shadow-right,
  .swiper-slide-shadow-top,
  .swiper-slide-shadow-bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
  }
  .swiper-slide-shadow {
    background: rgba(0, 0, 0, 0.15);
  }
  .swiper-slide-shadow-left {
    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-slide-shadow-right {
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-slide-shadow-top {
    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
  .swiper-slide-shadow-bottom {
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
  }
}
.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  transform-origin: 50%;
  box-sizing: border-box;
  border: 4px solid var(--swiper-preloader-color, var(--swiper-theme-color));
  border-radius: 50%;
  border-top-color: transparent;
}
.swiper:not(.swiper-watch-progress),
.swiper-watch-progress .swiper-slide-visible {
  .swiper-lazy-preloader {
    animation: swiper-preloader-spin 1s infinite linear;
  }
}
.swiper-lazy-preloader-white {
  --swiper-preloader-color: #fff;
}
.swiper-lazy-preloader-black {
  --swiper-preloader-color: #000;
}
@keyframes swiper-preloader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

    }
    
    .swiper-fade {
      &.swiper-free-mode {
        .swiper-slide {
          transition-timing-function: ease-out;
        }
      }
      .swiper-slide {
        pointer-events: none;
        transition-property: opacity;
        .swiper-slide {
          pointer-events: none;
        }
      }
      .swiper-slide-active {
        &,
        & .swiper-slide-active {
          pointer-events: auto;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination.swiper-pagination-hidden {
      opacity: 0;
    }
    .swiper-pagination-disabled > .swiper-pagination,
    .swiper-pagination.swiper-pagination-disabled {
      display: none !important;
    }
    /* Common Styles */
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      bottom: var(--swiper-pagination-bottom, 8px);
      top: var(--swiper-pagination-top, auto);
      left: 0;
      width: 100%;
    }
    /* Bullets */
    .swiper-pagination-bullets-dynamic {
      overflow: hidden;
      font-size: 0;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transform: scale(0.33);
      position: relative;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
      transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
      transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
      transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
      transform: scale(0.33);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
      transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet {
      width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
      height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
      display: inline-block;
      border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
      background: var(--swiper-pagination-bullet-inactive-color, #000);
      opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
    }
    button.swiper-pagination-bullet {
      border: none;
      margin: 0;
      padding: 0;
      box-shadow: none;
      -webkit-appearance: none;
              appearance: none;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet:only-child {
      display: none !important;
    }
    .swiper-pagination-bullet-active {
      opacity: var(--swiper-pagination-bullet-opacity, 1);
      background: var(--swiper-pagination-color, var(--swiper-theme-color));
    }
    .swiper-vertical > .swiper-pagination-bullets,
    .swiper-pagination-vertical.swiper-pagination-bullets {
      right: var(--swiper-pagination-right, 8px);
      left: var(--swiper-pagination-left, auto);
      top: 50%;
      transform: translate3d(0px, -50%, 0);
    }
    .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
      display: block;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      display: inline-block;
      transition: 200ms transform,
            200ms top;
    }
    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transition: 200ms transform,
            200ms left;
    }
    .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transition: 200ms transform,
        200ms right;
    }
    /* Fraction */
    .swiper-pagination-fraction {
      color: var(--swiper-pagination-fraction-color, inherit);
    }
    /* Progress */
    .swiper-pagination-progressbar {
      background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));
      position: absolute;
    }
    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      background: var(--swiper-pagination-color, var(--swiper-theme-color));
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: scale(0);
      transform-origin: left top;
    }
    .swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      transform-origin: right top;
    }
    .swiper-horizontal > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-horizontal,
    .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
      width: 100%;
      height: var(--swiper-pagination-progressbar-size, 4px);
      left: 0;
      top: 0;
    }
    .swiper-vertical > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-vertical,
    .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
      width: var(--swiper-pagination-progressbar-size, 4px);
      height: 100%;
      left: 0;
      top: 0;
    }
    .swiper-pagination-lock {
      display: none;
    }
    
    .community__root {
      --swiper-theme-color: #007aff;
      /*
      --swiper-preloader-color: var(--swiper-theme-color);
      --swiper-wrapper-transition-timing-function: initial;
      */
    }
    /* Navigation font end */
    .community__root {
      --swiper-pagination-color: var(--swiper-theme-color);
      --swiper-pagination-left: auto;
      --swiper-pagination-right: 8px;
      --swiper-pagination-bottom: 8px;
      --swiper-pagination-top: auto;
      --swiper-pagination-fraction-color: inherit;
      --swiper-pagination-progressbar-bg-color: rgba(0,0,0,0.25);
      --swiper-pagination-progressbar-size: 4px;
      --swiper-pagination-bullet-size: 8px;
      --swiper-pagination-bullet-width: 8px;
      --swiper-pagination-bullet-height: 8px;
      --swiper-pagination-bullet-border-radius: 50%;
      --swiper-pagination-bullet-inactive-color: #000;
      --swiper-pagination-bullet-inactive-opacity: 0.2;
      --swiper-pagination-bullet-opacity: 1;
      --swiper-pagination-bullet-horizontal-gap: 4px;
      --swiper-pagination-bullet-vertical-gap: 6px;
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-pagination.swiper-pagination-hidden {
      opacity: 0;
    }
    .swiper-pagination-disabled > .swiper-pagination,
    .swiper-pagination.swiper-pagination-disabled {
      display: none !important;
    }
    /* Common Styles */
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      bottom: var(--swiper-pagination-bottom, 8px);
      top: var(--swiper-pagination-top, auto);
      left: 0;
      width: 100%;
    }
    /* Bullets */
    .swiper-pagination-bullets-dynamic {
      overflow: hidden;
      font-size: 0;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transform: scale(0.33);
      position: relative;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
      transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
      transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
      transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
      transform: scale(0.33);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
      transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
      transform: scale(0.33);
    }
    .swiper-pagination-bullet {
      width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
      height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
      display: inline-block;
      border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
      background: var(--swiper-pagination-bullet-inactive-color, #000);
      opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
    }
    button.swiper-pagination-bullet {
      border: none;
      margin: 0;
      padding: 0;
      box-shadow: none;
      -webkit-appearance: none;
              appearance: none;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet:only-child {
      display: none !important;
    }
    .swiper-pagination-bullet-active {
      opacity: var(--swiper-pagination-bullet-opacity, 1);
      background: var(--swiper-pagination-color, var(--swiper-theme-color));
    }
    .swiper-vertical > .swiper-pagination-bullets,
    .swiper-pagination-vertical.swiper-pagination-bullets {
      right: var(--swiper-pagination-right, 8px);
      left: var(--swiper-pagination-left, auto);
      top: 50%;
      transform: translate3d(0px, -50%, 0);
    }
    .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
      display: block;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      display: inline-block;
      transition: 200ms transform,
            200ms top;
    }
    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
      left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transition: 200ms transform,
            200ms left;
    }
    .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
      transition: 200ms transform,
        200ms right;
    }
    /* Fraction */
    .swiper-pagination-fraction {
      color: var(--swiper-pagination-fraction-color, inherit);
    }
    /* Progress */
    .swiper-pagination-progressbar {
      background: var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25));
      position: absolute;
    }
    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      background: var(--swiper-pagination-color, var(--swiper-theme-color));
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: scale(0);
      transform-origin: left top;
    }
    .swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
      transform-origin: right top;
    }
    .swiper-horizontal > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-horizontal,
    .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
      width: 100%;
      height: var(--swiper-pagination-progressbar-size, 4px);
      left: 0;
      top: 0;
    }
    .swiper-vertical > .swiper-pagination-progressbar,
    .swiper-pagination-progressbar.swiper-pagination-vertical,
    .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
      width: var(--swiper-pagination-progressbar-size, 4px);
      height: 100%;
      left: 0;
      top: 0;
    }
    .swiper-pagination-lock {
      display: none;
    }
`;

export const MODAL_TITLE_STYLES = {
    fontWeight: "400",
    color: "var(--community-color-secondary-text)",
    fontSize: "1.25rem",
};

export const TIPPSPIEL_BOX_SHADOW =
    "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px";

export const LIGHT_BOX_STYLES = `
@keyframes closeWindow {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.ril__outer {
  background-color: rgba(0, 0, 0, 0.85);
  outline: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  -ms-content-zooming: none;
  -ms-user-select: none;
  -ms-touch-select: none;
  touch-action: none;
}

.ril__outerClosing {
  opacity: 0;
}

.ril__inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.ril__image,
.ril__imagePrev,
.ril__imageNext {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  max-width: none;
  -ms-content-zooming: none;
  -ms-user-select: none;
  -ms-touch-select: none;
  touch-action: none;
}

.ril__imageDiscourager {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.ril__navButtons {
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  height: 34px;
  padding: 40px 30px;
  margin: auto;
  cursor: pointer;
  opacity: 0.7;
}
.ril__navButtons:hover {
  opacity: 1;
}
.ril__navButtons:active {
  opacity: 0.7;
}

.ril__navButtonPrev {
  left: 0;
  background: rgba(0, 0, 0, 0.2)
    url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==')
    no-repeat center;
}

.ril__navButtonNext {
  right: 0;
  background: rgba(0, 0, 0, 0.2)
    url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+')
    no-repeat center;
}

.ril__downloadBlocker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
  background-size: cover;
}

.ril__caption,
.ril__toolbar {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
}

.ril__caption {
  bottom: 0;
  max-height: 150px;
  overflow: auto;
}

.ril__captionContent {
  padding: 10px 20px;
  color: #fff;
}

.ril__toolbar {
  top: 0;
  height: 50px;
}

.ril__toolbarSide {
  height: 50px;
  margin: 0;
}

.ril__toolbarLeftSide {
  padding-left: 20px;
  padding-right: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ril__toolbarRightSide {
  padding-left: 0;
  padding-right: 20px;
  flex: 0 0 auto;
}

.ril__toolbarItem {
  display: inline-block;
  line-height: 50px;
  padding: 0;
  color: #fff;
  font-size: 120%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ril__toolbarItemChild {
  vertical-align: middle;
}

.ril__builtinButton {
  width: 40px;
  height: 35px;
  cursor: pointer;
  border: none;
  opacity: 0.7;
}
.ril__builtinButton:hover {
  opacity: 1;
}
.ril__builtinButton:active {
  outline: none;
}

.ril__builtinButtonDisabled {
  cursor: default;
  opacity: 0.5;
}
.ril__builtinButtonDisabled:hover {
  opacity: 0.5;
}

.ril__closeButton {
  background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=')
    no-repeat center;
}

.ril__zoomInButton {
  background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+')
    no-repeat center;
}

.ril__zoomOutButton {
  background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=')
    no-repeat center;
}

.ril__outerAnimating {
  animation-name: closeWindow;
}

@keyframes pointFade {
  0%,
  19.999%,
  100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}

.ril__loadingCircle {
  width: 60px;
  height: 60px;
  position: relative;
}

.ril__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.ril__loadingCirclePoint::before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}
.ril__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}
.ril__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}
.ril__loadingCirclePoint:nth-of-type(1)::before,
.ril__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}
.ril__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}
.ril__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}
.ril__loadingCirclePoint:nth-of-type(2)::before,
.ril__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}
.ril__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}
.ril__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}
.ril__loadingCirclePoint:nth-of-type(3)::before,
.ril__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}
.ril__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}
.ril__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}
.ril__loadingCirclePoint:nth-of-type(4)::before,
.ril__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}
.ril__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}
.ril__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}
.ril__loadingCirclePoint:nth-of-type(5)::before,
.ril__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}
.ril__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}
.ril__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}
.ril__loadingCirclePoint:nth-of-type(6)::before,
.ril__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}
.ril__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}
.ril__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}
.ril__loadingCirclePoint:nth-of-type(7)::before,
.ril__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.ril__loadingContainer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ril__imagePrev .ril__loadingContainer,
.ril__imageNext .ril__loadingContainer {
  display: none;
}

.ril__errorContainer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.ril__imagePrev .ril__errorContainer,
.ril__imageNext .ril__errorContainer {
  display: none;
}

.ril__loadingContainer__icon {
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
`;

export const CROPPER_STYLES = `
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:02.731Z
 */

.cropper-container {
  direction: ltr;
  font-size: 0;
  line-height: 0;
  position: relative;
  -ms-touch-action: none;
      touch-action: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.cropper-container img {
    backface-visibility: hidden;
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    width: 100%;
  }

.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.cropper-wrap-box,
.cropper-canvas {
  overflow: hidden;
}

.cropper-drag-box {
  background-color: #fff;
  opacity: 0;
}

.cropper-modal {
  background-color: #000;
  opacity: 0.5;
}

.cropper-view-box {
  display: block;
  height: 100%;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
  overflow: hidden;
  width: 100%;
}

.cropper-dashed {
  border: 0 dashed #eee;
  display: block;
  opacity: 0.5;
  position: absolute;
}

.cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: calc(100% / 3);
    left: 0;
    top: calc(100% / 3);
    width: 100%;
  }

.cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: calc(100% / 3);
    top: 0;
    width: calc(100% / 3);
  }

.cropper-center {
  display: block;
  height: 0;
  left: 50%;
  opacity: 0.75;
  position: absolute;
  top: 50%;
  width: 0;
}

.cropper-center::before,
  .cropper-center::after {
    background-color: #eee;
    content: ' ';
    display: block;
    position: absolute;
  }

.cropper-center::before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px;
  }

.cropper-center::after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px;
  }

.cropper-face,
.cropper-line,
.cropper-point {
  display: block;
  height: 100%;
  opacity: 0.1;
  position: absolute;
  width: 100%;
}

.cropper-face {
  background-color: #fff;
  left: 0;
  top: 0;
}

.cropper-line {
  background-color: #39f;
}

.cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
  }

.cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px;
  }

.cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px;
  }

.cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0;
  }

.cropper-point {
  background-color: #39f;
  height: 5px;
  opacity: 0.75;
  width: 5px;
}

.cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%;
  }

.cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px;
  }

.cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%;
  }

.cropper-point.point-s {
    bottom: -3px;
    cursor: s-resize;
    left: 50%;
    margin-left: -3px;
  }

.cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px;
  }

.cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px;
  }

.cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px;
  }

.cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    height: 20px;
    opacity: 1;
    right: -3px;
    width: 20px;
  }

@media (min-width: 768px) {

.cropper-point.point-se {
      height: 15px;
      width: 15px;
  }
    }

@media (min-width: 992px) {

.cropper-point.point-se {
      height: 10px;
      width: 10px;
  }
    }

@media (min-width: 1200px) {

.cropper-point.point-se {
      height: 5px;
      opacity: 0.75;
      width: 5px;
  }
    }

.cropper-point.point-se::before {
    background-color: #39f;
    bottom: -50%;
    content: ' ';
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%;
  }

.cropper-invisible {
  opacity: 0;
}

.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}

.cropper-hide {
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}

.cropper-hidden {
  display: none !important;
}

.cropper-move {
  cursor: move;
}

.cropper-crop {
  cursor: crosshair;
}

.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}
`;
